import { render, staticRenderFns } from "./StatusSelector.vue?vue&type=template&id=65f116b8&"
import script from "./StatusSelector.vue?vue&type=script&lang=ts&"
export * from "./StatusSelector.vue?vue&type=script&lang=ts&"
import style0 from "./StatusSelector.vue?vue&type=style&index=0&id=65f116b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports